// PostHog-Helfer ohne SDK-Abhaengigkeit: gleiche Personen- und Fehler-Eigenschaften auf Web und Mobile.

export type AnalyticsPlatform = 'web' | 'mobile';
export type AnalyticsValue = string | number | boolean | null;

export interface ErrorReportContext {
  area: string;
  action: string;
  /** Web-Route */
  route?: string;
  /** Mobile-Screen */
  screen?: string;
  organizationId?: string | null;
  properties?: Record<string, AnalyticsValue | undefined>;
}

/** Wandelt beliebige geworfene Werte in ein Error-Objekt fuer captureException. */
export function toError(error: unknown): Error {
  if (error instanceof Error) return error;
  if (typeof error === 'string') return new Error(error);
  if (error && typeof error === 'object' && 'message' in error && typeof error.message === 'string') {
    return new Error(error.message);
  }
  try {
    return new Error(JSON.stringify(error));
  } catch {
    return new Error('Unknown error');
  }
}

export function buildErrorReportProperties(
  platform: AnalyticsPlatform,
  context: ErrorReportContext,
): Record<string, AnalyticsValue> {
  const properties: Record<string, AnalyticsValue> = {
    app_platform: platform,
    error_area: context.area,
    error_action: context.action,
  };

  for (const [key, value] of Object.entries(context.properties ?? {})) {
    if (value !== undefined) properties[key] = value;
  }
  if (context.route !== undefined) properties.route = context.route;
  if (context.screen !== undefined) properties.screen = context.screen;
  if (context.organizationId) properties.organization_id = context.organizationId;

  return properties;
}

/** Personen-Eigenschaften fuer identify(); snake_case wie bisher auf Web. */
export function buildIdentifyProperties(
  user: { email: string; firstName?: string | null; lastName?: string | null },
  organizationId?: string | null,
): Record<string, AnalyticsValue> {
  return {
    email: user.email,
    first_name: user.firstName ?? null,
    last_name: user.lastName ?? null,
    organization_id: organizationId ?? null,
  };
}
